import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { userApi } from 'src/Services/API';
import { UpdateUserConsentsDto, UserWithPrivateInfoDto } from 'src/Services/API/generated';

export const useAcceptTerms = (
  options?: UseMutationOptions<UserWithPrivateInfoDto, unknown, UpdateUserConsentsDto>
) => {
  const queryClient = useQueryClient();
  return useMutation<UserWithPrivateInfoDto, unknown, UpdateUserConsentsDto>(
    'accept-terms',
    async data => {
      const response = await userApi.userControllerUpdateConsents(data);
      return response.data;
    },
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        queryClient.removeQueries(['fetch-user']);

        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
